import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Button, Spinner } from "reactstrap";
import DataTable from "react-data-table-component";
import {
  Add,
  ViewGeneralSettingTitle,
  GeneralSettingTitle,
} from "../../../Utils/Constants";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
import axios from "axios";
import { baseUrl, mediaUrl } from "../../../Utils/FileUpload";
import { GeneralSetting } from "../../../Types/Tables.type";
import FilterComponent from "../../../Components/Tables/DataTables/Common/FilterComponent";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Btn } from "../../../AbstractElements";
import { useNavigate } from "react-router-dom";

export default function ViewGeneralSetting() {
  const [filterText, setFilterText] = useState("");
  const [filteredItems, setFilteredItems] = useState<GeneralSetting[]>([]);
  const [refresh, setRefresh] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [disabledDelete, setDisabledDelete] = useState<string | null>(null);
  const [disableAllDelete, setDisableAllDelete] = useState(false);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${baseUrl}general_setting/getall`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data: GeneralSetting[] = response.data;
        // setFilteredItems(
        //   data
        //     .filter((brand) => brand.is_deleted === 0)
        //     .sort((a, b) => b.is_active - a.is_active) // 👈 actived ones first
        // );
        setFilteredItems(data);
        // console.log(data)
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [refresh]);

  const handleAdd = () => {
    navigate("/add_general_setting");
  };

  const filteredData = filteredItems.filter((item: GeneralSetting) => {
    const search = filterText.toLowerCase();
    return (
      (item.phone || "").toLowerCase().includes(search) ||
      (item.address || "").toLowerCase().includes(search) ||
      (item.email || "").toLowerCase().includes(search) ||
      (item.about_us || "").toLowerCase().includes(search) ||
      (item.contact_us || "").toLowerCase().includes(search) ||
      (item.smtp_password || "").toLowerCase().includes(search) ||
      (item.term_condition || "").toLowerCase().includes(search) ||
      (item.logo || "").toLowerCase().includes(search)
    );
  });

  const handleEdit = (id: string) => {
    navigate("/edit_general_setting", { state: { id: id } });
  };

  const handleDelete = (id: string) => {
    setDisabledDelete(id);
    setDisableAllDelete(true);
    const confirmToast = () =>
      toast.warn(
        <div>
          <div>Are you sure you want to delete this generalSetting?</div>
          <div className="d-flex justify-content-end mt-2">
            <Button color="danger" onClick={() => confirmDelete(id)}>
              Yes
            </Button>
            <Button
              color="secondary"
              onClick={() => {
                setDisabledDelete(null);
                setDisableAllDelete(false);
                toast.dismiss();
              }}
              className="ms-2"
            >
              Cancel
            </Button>
          </div>
        </div>,
        {
          position: "top-right",
          autoClose: false,
          closeOnClick: false,
          closeButton: false,
          draggable: false,
          onClose: () => {
            setDisableAllDelete(false);
            setDisabledDelete(null);
          },
        }
      );

    const confirmDelete = async (id: string) => {
      setDisabledDelete(null);
      setDisableAllDelete(false);
      toast.dismiss();
      try {
        await axios.post(
          `${baseUrl}general_setting/delete`,
          { id },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toast.success(`General Setting Deleted Successfully`, {
          position: "top-right",
          autoClose: 1000,
          closeOnClick: true,
        });
        setFilteredItems((prevItems) =>
          prevItems.filter((item) => item.id !== id)
        );
      } catch (error) {
        console.error("Error deleting general setting:", error);
        toast.error("An error occurred while deleting the general setting", {
          position: "top-right",
          autoClose: 1000,
          closeOnClick: true,
        });
      }
    };

    confirmToast();
  };

  // Define columns with actions
  const generalSettingTableColumns = [
    {
      name: "Logo",
      cell: (row: GeneralSetting) => (
        <img
          src={`${mediaUrl}/${row.logo}`}
          alt={row.logo}
          width={25}
          height={25}
          style={{
            objectFit: "cover",
            borderRadius: "10px",
          }}
        />
      ),
      // sortable: true,
      width: "8%",
    },
    {
      name: <div>Contact Number</div>,
      selector: (row: GeneralSetting) => row.phone,
      sortable: true,
      width: "15%",
    },
    {
      name: "Address",
      selector: (row: GeneralSetting) => row.address,
      sortable: true,
      width: "15%",
      wrap: true
    },
    {
      name: "Email",
      selector: (row: GeneralSetting) => row.email,
      sortable: true,
      width: "15%",
      wrap: true
    },
    {
      name: "About Us",
      cell: (row: GeneralSetting) => (
        <div
          style={{
            lineHeight: "1.5",
            padding: "8px 0",
            maxHeight: "180px",
            overflowY: "auto",
            wordBreak: "break-word",
          }}
          dangerouslySetInnerHTML={{ __html: row.about_us || "—" }}
        />
      ),
      selector: (row: GeneralSetting) =>
        (row.about_us || "").replace(/<[^>]*>?/gm, " ").trim(),
      sortable: true,
      width: "25%",
      wrap: true,
    },
    {
      name: "Currency",
      selector: (row: GeneralSetting) => row.currency,
      sortable: true,
      width: "12%",
    },
    {
      name: "Actions",
      cell: (row: GeneralSetting) => (
        <div className="d-flex justify-content-between">
          <Button
            color="primary"
            size="sm"
            onClick={() => handleEdit(row.id)}
            style={{
              marginRight: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            title="Edit"

          >
            <i className="icon-pencil-alt" />
          </Button>
          <Button
            color="danger"
            size="sm"
            onClick={() => handleDelete(row.id)}
            disabled={disabledDelete === row.id || disableAllDelete}
            style={{
              marginRight: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            title="Delete"

          >
            <i className="icon-trash" />
          </Button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      // button: true,
      width: "10%",
    },
  ];

  // Show a loading spinner while data is being fetched
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spinner color="primary" />
      </div>
    );
  }
  const customStyles = {
    headCells: {
      style: {
        fontSize: "16px",
        fontWeight: "600",
        color: "#308e87",
        backgroundColor: "#f8f9fa",
        borderBottom: "2px solid #308e87",
      },
    },
    rows: {
      style: {
        borderBottom: "1px solid #dee2e6",
      },
    },
    table: {
      style: {
        border: "1px solid #dee2e6",
        borderRadius: "8px",
      },
    },
  };
  return (
    <>
      <Breadcrumbs
        pageTitle={ViewGeneralSettingTitle}
        parent={GeneralSettingTitle}
        title={ViewGeneralSettingTitle}
      />
      <Col xl={12} className="mb-lg-3">
        <Card>
          <CardBody>
            {filteredItems.length === 0 && (
              <Col xs={12} className="mt-2 d-flex justify-content-end mb-3">
                <Btn color="primary" onClick={handleAdd}>
                  {Add}
                </Btn>
              </Col>
            )}
            {/* <div className="mb-3">
              <FilterComponent
                onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setFilterText(e.target.value)
                }
                filterText={filterText}
              />
            </div> */}
            <div className="table-responsive">
              <DataTable
                data={filteredData}
                columns={generalSettingTableColumns}
                pagination
                highlightOnHover
                striped
                customStyles={customStyles}
              />
            </div>
          </CardBody>
        </Card>
      </Col>
      <ToastContainer />
    </>
  );
}
